import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import AuthApiService from "services/authApiService";

export const fetchClient = createAsyncThunk(
  "client/fetchClient",
  async ({
    clientSlug,
    langCode = "en",
    apiHeaders,
  }: {
    clientSlug: string;
    langCode?: string;
    apiHeaders: {
      token?: string;
      clientSlug?: string;
      locale?: string;
      clientId?: string;
    };
  }) => {
    try {
      const response = await AuthApiService({
        method: "get",
        endpoint: `/client/v1/get-client/${clientSlug}`,
        lang: langCode,
        apiHeaders,
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.message || "Failed to fetch client"
        );
      } else {
        throw new Error("Failed to fetch client");
      }
    }
  }
);
